<template>
  <ul class="nav nav-mobile-menu">
    <li class="mobile-search-item">
      <md-field>
        <label>Search</label>
        <md-input v-model="search" type="text"></md-input>
      </md-field>
    </li>

    <li class="sidebar-item">
      <drop-down>
        <a slot="title" class="nav-link dropdown-toggle" data-toggle="dropdown">
          <span class="nav-icon">
            <md-icon>person</md-icon>
          </span>
          <p class="nav-text">Account</p>
        </a>
        <ul class="dropdown-menu-wrapper">
          <logout />
        </ul>
      </drop-down>
    </li>
  </ul>
</template>

<script>
export default {
  inject: {
    sidebarContext: { default: () => ({ collapsed: false }) }
  },
  data () {
    return {
      search: null,
      selectedEmployee: null,
      employees: [
        'Jim Halpert',
        'Dwight Schrute',
        'Michael Scott',
        'Pam Beesly',
        'Angela Martin',
        'Kelly Kapoor',
        'Ryan Howard',
        'Kevin Malone'
      ]
    }
  }
}
</script>

<style scoped>
.nav-mobile-menu {
  display: none !important;
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

@media (max-width: 991px) {
  .nav-mobile-menu {
    display: flex !important;
    flex-direction: column;
    gap: 4px;
  }
  
  .mobile-search-item {
    padding: 0 14px;
    margin-bottom: 8px;
  }

  .sidebar-item {
    display: block;
    width: 100%;
  }

  .nav-link {
    display: flex;
    align-items: center;
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid transparent;
    color: #667085 !important;
    text-decoration: none;
    cursor: pointer;
    box-sizing: border-box;
    transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  }

  .nav-link:hover,
  .nav-link.is-selected {
    background-color: #F0FFF0;
    border: 1px solid #E5FFE6;
    color: #101828 !important;
    font-weight: 500;
  }

  .nav-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    min-width: 24px;
    height: 24px;
    color: inherit !important;
  }

  .nav-icon .md-icon {
    font-size: 20px !important;
    color: inherit !important;
  }

  .nav-text {
    flex: 1;
    margin: 0 0 0 10px;
    font-size: 15px;
    font-weight: 500;
    white-space: nowrap;
  }

  .dropdown-menu-wrapper {
    padding: 4px 0 4px 12px;
    margin: 4px 0 0 0;
    list-style: none;
    display: flex;
    flex-direction: column;
  }
}
</style>